export enum PlannerCommentStatusType {
  Bad = 0,
  Neutral = 1,
  Good = 2,
  VeryGood = 3,
}

export interface OperationsPlannerDriverPerformanceCommentDto {
  driverId: string;
  startDate: string | null;
  endDate: string | null;
  comment: string | null;
  status: PlannerCommentStatusType | null;
}

export interface OperationsPlannerDriverPerformanceDto {
  driverId: string;
  driverName: string | null;
  trailerType: string | null;
  gross: number;
  rpm: number;
  comment: string | null;
  status: PlannerCommentStatusType | null;
}

export interface OperationsPlannerDispatcherPerformanceDto {
  dispatcherId: string;
  dispatcherNickname: string | null;
  dispatcherWorkPhoneNumber: string | null;
  drivers: OperationsPlannerDriverPerformanceDto[];
}

export interface OperationsPlannerPerformanceResponseDto {
  startDate: string;
  endDate: string;
  dispatchers: OperationsPlannerDispatcherPerformanceDto[];
}
